import { render, staticRenderFns } from "./foodAndBeverages.vue?vue&type=template&id=090ade08&scoped=true"
import script from "./foodAndBeverages.vue?vue&type=script&lang=js"
export * from "./foodAndBeverages.vue?vue&type=script&lang=js"
import style0 from "./foodAndBeverages.vue?vue&type=style&index=0&id=090ade08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090ade08",
  null
  
)

export default component.exports